import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {regionFields} from "../../locations/regions/regions.graphql";
import {districtFields} from "../../locations/districts/districts.graphql";
import {wardFields} from "../../locations/wards/wards.graphql";
import {streetFields} from "../../locations/streets/streets.graphql";
import {institutionFields} from "../../system-settings/institution/institution.graphql";
import {serviceCategoryFields} from "../../system-settings/service-category/service-category.graphql";

export const branchOfficeFields = `
id
officeUniqueId
officeName
officeCoordinates
officeRegions {
  ${regionFields}
}
officeDistrics {
  ${districtFields}
}
officeWards {
  ${wardFields}
}
officeStreets {
  ${streetFields}
}
`

export const serviceCoProviderFields = `
id
coproviderUniqueId
coproviderCollaborationPurpose
coproviderInstitution {
  ${institutionFields}
}
`

export const GET_ALL_OFFICE_BRANCH = gql`
query GetAllOfficeBranch($filtering: OfficeBranchFilteringInputObject) {
  getAllOfficeBranch(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${branchOfficeFields}
    }
  }
}
`

export const CREATE_INSTITUTION_OFFICE_BRANCH_MUTATION = gql`
mutation CreateInstitutionOfficeBranchMutation($input: InstitutionOfficesInputObjects!) {
  createInstitutionOfficeBranchMutation(input: $input) {
   ${baseResponseGraphqlField}
    data {
      ${branchOfficeFields}
    }
  }
}
`

export const UPDATE_INSTITUTION_OFFICE_BRANCH_MUTATION = gql`
mutation UpdateInstitutionOfficeBranchMutation($input: InstitutionOfficesInputObjects!) {
  updateInstitutionOfficeBranchMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${branchOfficeFields}
    }
  }
}
`

export const DELETE_INSTITUTION_OFFICE_BRANCH = gql`
mutation DeleteInstitutionOfficeBranchMutation($officeUniqueId: String) {
  deleteInstitutionOfficeBranchMutation(officeUniqueId: $officeUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`

